<template>
	<div class="edit-modal">
		<div class="edit-modal-content">
			<form action="" method="POST" @submit.prevent="$emit('save', items)">
				<div class="title">
					<span>
						{{ title }}
					</span>
					<button
						class="btn close-icon"
						type="button"
						@click="$emit('close-modal')"
					>
						<img
							src="/static/img/icon-close.svg"
							alt="cerrar modal"
							height="24px"
							width="24px"
						>
					</button>
				</div>
				<div class="section text-center">
					<div class="section-header text-left">
						<div
							v-for="(item, index) in items"
							:key="index"
							class="section-item border-bottom"
						>
							<img :src="item.img" alt="" height="52px" width="83px">
							<button
								v-if="itemsGreaterThanOne"
								class="btn-close"
								type="button"
								@click="$emit('remove-img', index)"
							>
								<img
									src="/static/img/remove-image.svg"
									alt=""
									height="16px"
									width="16px">
							</button>
						</div>
					</div>
					<div class="section-body">
						<upload-image
							:visible-more="false"
							label-for="banner-id"
							label-ref="banner-img"
							:url-image="urlImage"
							@send-image="$emit('send-image', $event)"
							class="full-width"
						/>
						<button 
							@click.prevent="$emit('add-image')"
							:class="[
							'btn-add',
							addSection ? 'disable-class' : null]"
							:disabled="addSection">
							<img 
								src="/static/img/icon-plus.svg"
								alt="button-add"
								>
						</button>
					</div>
					<button
						class="btn btn-save mt-32"
						type="submit"
						@add-image="$emit('add-image')"
					>
						Guardar
					</button>
				</div>
			</form>
		</div>
	</div>
</template>

<script>
	import uploadImage from './upload-image';

	function addSection() {
		return !this.urlImage;
	}

	function itemsGreaterThanOne() {
		return this.items.length > 1;
	}

	export default {
		name: 'edit-modal-banner',
		components: {
			uploadImage,
		},
		computed: {
			addSection,
			itemsGreaterThanOne,
		},
		props: {
			items: {
				default: () => [],
				type: Array,
			},
			title: String,
			urlImage: String,
		},
	};
</script>

<style lang="scss" scoped>
	.disable-class {
		cursor: not-allowed;
		opacity: 0.25;
	}

	.btn-add {
		background-color: #001d32;
    border-radius: 4px;
    height: 30px;
    margin-left: 15px;
    padding: 5px 0px;
    width: 30px;
	}

	.caption {
		font-size: 10px;
	}

	.close-icon {
		height: 24px;
		margin: 0px;
		padding: 0px;
		width: 24px;
	}

	.form-input {
		border-radius: 4px;
		outline: 0;
		width: 100%;
	}

	.edit-modal {
		align-items: center;
		background-color: rgba(0, 0, 0, .5);
		display: flex;
		height: 100vh;
		justify-content: center;
		position: fixed;
		top: 0px;
		width: 100vw;
		z-index: 16;

		&-content {
			background-color: map-get($colors, white);
			max-width: 537px;
			width: 90%;
			z-index: 16;
		}

		.section {
			padding: 36px 46px 24px;

			&-item {
				display: inline-block;
				margin-right: 36px;
				padding-bottom: 15px;
				position: relative;
				text-align: left;

				&:last-child {
					margin-right: 0px;
				}
			}
		}
	}

	.title {
		align-items: center;
		background-color: map-get($colors, black-dark);
		color: map-get($colors, white);
		display: flex;
		flex-wrap: wrap;
		font-family: map-get($fonts, maison-bold);
		font-size: 24px;
		justify-content: space-between;
		height: 59px;
		padding: 0px 37px;
		text-transform: uppercase;
	}

	.btn-save {
		background-color: map-get($colors, black-dark);
		color: map-get($colors, white);
		font-family: map-get($fonts, open-bold);
		font-size: 14px;
		height: 45px;
		width: 132px;

		&.mt-32 {
			margin-top: 32px;
		}
	}

	.btn-close {
		background-color: map-get($colors, white);
		border-radius: 100%;
		box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, .5);
		height: 35px;
		position: absolute;
		right: -20px;
		top: 10px;
		width: 35px;

		img {
			vertical-align: middle;
		}
	}

	.text-left {
		align-items: center;
		display: flex;
		flex-wrap: wrap;
		text-align: left;
	}

	.text-center {
		text-align: center;
	}

	.full-width {
		width: 100% !important;
	}

	.section-body {
		@include display-flex();
		align-items: center;
	}
</style>



// WEBPACK FOOTER //
// src/components/commons/edit-modal-banner.vue